module.exports = __webpack_public_path__ + "static/sportovni-den-2022-3591249a00f57157d503c1ed603eb3d4.jpg";